import { createRoot } from "react-dom/client";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { BrowserRouter } from "react-router-dom";
import { LanguageProvider } from "./Contexts/LangContext";
import { AuthProvider } from "./Contexts/AuthContext";
import App from "./App.jsx";
import "./index.css";
import { SocketProvider } from "./Contexts/SocketContext";
import { RoomProvider } from "./Contexts/RoomContext";
import { BrandingProvider } from "./Contexts/BrandingContext.jsx";

import { Provider } from "react-redux";
import Store from "./Redux/Store";
import { StrictMode } from "react";

const theme = extendTheme({
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  },
  styles: {
    global: {
      body: {
        bg: "white",
        color: "gray.800",
      },
    },
  },
});

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").then(() => {
      console.log("[SW] Registered");
    });
  });
}

createRoot(document.getElementById("root")).render(
  <Provider store={Store.Configuration}>
    <BrowserRouter>
      <AuthProvider>
        <SocketProvider>
          <BrandingProvider>
            <ChakraProvider theme={theme}>
              <LanguageProvider>
                <RoomProvider>
                  <App />
                </RoomProvider>
              </LanguageProvider>
            </ChakraProvider>
          </BrandingProvider>
        </SocketProvider>
      </AuthProvider>
    </BrowserRouter>
  </Provider>
);
